import React, { FC } from 'react';
// import classNames from 'classnames';
// import Link from 'next/link';
import { Link } from '../../components/Link';

import NewsTag from '../../components/NewsTag';

import styles from './NewsDatailBanner.module.scss';

export interface DataType {
  [key: string]: string;
}
interface Props {
  newsTitle: string;
  newsType: string;
  newsTypeId: number;
  newsTypeKey: string;
  newsDate: string;
  newsOrigin: string;
  newsTextData: DataType;
}
const NewsDatailBanner: FC<Props> = (props) => {
  const { newsTitle, newsType, newsTypeId, newsDate, newsOrigin, newsTextData, newsTypeKey } = props;

  const newsPath = '/news';

  const getCategoryUrl = (category: string) => {
    const searchParams = new URLSearchParams();
    if (category) {
      searchParams.append('category', `${category}`);
    }
    return `${newsPath}?${searchParams}`;
  };

  const renderLinkNode = (href: string, nodeText: string) => {
    return (
      <>
        <Link href={href} prefetch={false} legacyBehavior>
          <a className="hover:text-black-dark hover:underline">{nodeText}</a>
        </Link>
        <i className="pl-1 pr-1.5">|</i>
      </>
    );
  };

  return (
    <section className={styles['news-detail-banner-box']}>
      <div className={styles['router-info-box']}>
        {renderLinkNode('/news', newsTextData.newsTitleText)}
        {renderLinkNode(getCategoryUrl(newsTypeKey), newsType)}
        <span>{newsTextData.newsDetailText}</span>
      </div>
      <div className={`${styles['news-title']}`}> {newsTitle}</div>
      <div className={styles['news-info-box']}>
        {newsType ? <NewsTag tagVal={newsTypeId} tagName={newsType} /> : null}
        {newsDate ? <span className={styles['news-info-item']}>{newsDate}</span> : null}
        {newsOrigin && (
          <span className={styles['news-info-item']}>
            {newsTextData.NewsSrcText}：{newsOrigin || '美团'}
          </span>
        )}
      </div>
    </section>
  );
};
NewsDatailBanner.defaultProps = {};

NewsDatailBanner.displayName = 'NewsDatailBanner';
export default NewsDatailBanner;
